import React from "react";
import { FavouritesDisplay } from "../../features/favourites";
import { PageHeader } from "../../components/utilities";

const PersonalFavouritesPage = () => {
    return <React.Fragment>
        <PageHeader>
            <h2>My Favourites</h2>
        </PageHeader>
        <section className="container my-3">
            <div className="card">
                <div className="card-body">
                    <FavouritesDisplay openPageOnMaxPagesReached={false} />
                </div>
            </div>
        </section>
    </React.Fragment>
};

export default PersonalFavouritesPage;